class Route{
    //获取路由传参，根据传入参数作为key值，返回value值
    /*static getQueryString(name){
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      const search = window.location.search.split('?')[1] || '';
      const r = search.match(reg) || [];
      return r[2];
    }*/
    //获取路由传参，将参数转化为对象，返回该对象
    static getQueryObject(){
        var url = location.search //获取url中"?"符后的字串  <a href="tel:400-888-6633">拨打电话<a>
        var routeQuery = {}
        if (url.indexOf("?") != -1) {
            var str = decodeURI(url.substr(1))
            var strs = str.split("&")
            for (var i = 0; i < strs.length; i++) {
                routeQuery[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1])
            }
        }
        return routeQuery
    }
}
export default Route